import { getActiveProduct, getActiveProductSelector } from './utils';

/**
 * Returns the targeted product for this component.  Could be
 *   - product
 *   - product.familyProduct
 *   - quickshop.product
 *
 *  or any other product "viewers"
 *
 * `this` is assumed to be a productComponent or some other product sub-component in the hierarchy
 */
export function getTargetedProduct(state) {
    const f = function f() {
        return getActiveProduct(state, this.multipleIndex);
    }.bind(this);

    return f(state);
}

/* eslint-disable no-extra-parens */
export function scopedWatch(state, objectPath) {
    return (function(objectPath) {
        return function() {
            const productSelector = getActiveProductSelector(state, this.multipleIndex);
            return `${productSelector}.${objectPath}`;
        };
    }(objectPath));
}
/* eslint-enable no-extra-parens */

/**
 * Standard render for *most* product subcomponents
 * "this" should be the product component
 * @param store - Redux store
 * @param extraRenderContext - Extra stuff to pass into the render function on top of the base
 */
export function onStateChange(store, watchValue, oldValue, newValue, extraRenderContext) {
    const f = function f() {
        const product = this.getTargetedProduct(store.getState());

        if (!product || _.isEmpty(product)) {
            return;
        }

        const renderContext = _.merge({
            product: product,
            disableZoom: this.disableZoom,
            forFamilyProduct: this.forFamilyProduct,
            productMeta: _.get(product, 'productMeta'),
            productBopis: _.get(product, 'productBopis'),
            productReviews: _.get(product, 'productReviews'),
            productControls: _.get(product, 'productControls'),
            productDetails: _.get(product, 'productDetails'),
            primarySlice: _.get(product, 'skuInfo.primarySlice'),
            secondarySlice: _.get(product, 'skuInfo.secondarySlice'),
            innerProduct: _.get(product, 'product')
        }, extraRenderContext);

        this.render(store, this, renderContext, store);
    }.bind(this);

    return f();
}
